import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule, MatPaginatorIntl }  from '@angular/material/paginator';
import { MatIconModule}  from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatCheckboxModule } from '@angular/material/checkbox';
import {MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatTreeModule } from '@angular/material/tree';
import {MatSelectModule } from '@angular/material/select';
import {MatFormFieldModule } from '@angular/material/form-field';
import {MatSnackBarModule } from '@angular/material/snack-bar';
import {MatTableModule } from '@angular/material/table';
import {MatTooltipModule } from '@angular/material/tooltip';
import {MatProgressBarModule } from '@angular/material/progress-bar';
import {MatTabsModule } from '@angular/material/tabs';
import {MatMenuModule } from '@angular/material/menu';
import {MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import { CustomPaginator } from './CustomPaginatorConfiguration';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MatInputModule,
		MatButtonModule,
		MatPaginatorModule,
		MatIconModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatCheckboxModule,
		MatSlideToggleModule,
		MatTreeModule,
		MatSelectModule,
		MatFormFieldModule,
		MatSnackBarModule,
		MatTableModule,
		MatTooltipModule,
		MatProgressBarModule,
		MatTabsModule,
		MatMenuModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		MatExpansionModule,
	],
	exports: [
		MatInputModule,
		MatButtonModule,
		MatPaginatorModule,
		MatIconModule,
		MatDatepickerModule,
		MatCheckboxModule,
		MatSlideToggleModule,
		MatTreeModule,
		MatSelectModule,
		MatFormFieldModule,
		MatSnackBarModule,
		MatTableModule,
		MatTooltipModule,
		MatProgressBarModule,
		MatTabsModule,
		MatMenuModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatNativeDateModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		MatExpansionModule,
	],
	providers: [
		{ provide: MatPaginatorIntl, useValue: CustomPaginator() }

	]
})
export class MaterialModule { }
